<template>
  <div class="container">
    <content-layout></content-layout>
  </div>
</template>

<script setup>
  import ContentLayout from '../components/layout/ContentLayout.vue'
  import { onMounted } from 'vue'

  onMounted(() => {
    document.title = "Reggenius | Welcome";
  });
</script>

<style scoped>
  .container {
    min-height: 100vh;
    width: 100%;
    color: white;
    background-color: black;
  }
</style>